/** @file compassAngle: where a world bearing points on screen for the orbit camera (clockwise from up). */

/**
 * `bearing` is clockwise from north (0 N, 90 E, 180 S, 270 W). Camera yaw 0 looks north and yaw orbits
 * counter-clockwise seen from above (yaw 90 stands east looking west), so screen-up has bearing `-yaw` and a bearing
 * shows at `bearing + yaw` degrees clockwise from screen-up, in [0, 360). A body facing (pose yaw, 0 = south,
 * clockwise) has bearing `180 + facing`.
 */
export function compassAngle(bearingDeg: number, cameraYawDeg: number): number {
  const a = (bearingDeg + cameraYawDeg) % 360;
  return a < 0 ? a + 360 : a + 0;
}
